import _ from "lodash";
import Vue from "vue";
import constant from "@/helper/constant";
import { getNumberFormatter } from "@/helper/currencyFormat";
import { getLangSpecificAttribute } from "@/helper/Languages";
import axios from "axios";
import { getLangSpecificContent } from "@/helper/LanguageHelperV2";
import MasterService from "@/services/MasterService";
import { authenticationService } from "@/services/AuthenticationService";
import { BASEURL, IMGBASEURL } from "@/config/index";
import { trans } from "../../helper/trans/trans";

let userDetailsArray = {
  cinema_id: null,
  email_id: null,
  first_name: null,
  last_name: null,
  middle_name: null,
  mobile_no: null,
  role_id: null,
  user_id: null,
  username: null,
  role_name: null,
  distributor_id: null,
  cine_name: null,
  cine_direct_sale: null,
  cine_include_float_amount: null,
  cine_sell_fnb_in_boxoffice: null,
  pos_location_access: null,
  is_premier_kitchen_user: "N",
};
const data = function() {
    return {
    AdminError:
      "Sorry! Something went wrong. kindly contact your administrator",
    GridViewFlag: false,
    NoRecords: "NoRecords",
    BASE_URL: constant.imageBaseURL,
    REPORT_BASE_URL:  constant.hasOwnProperty('reportUrl') ? constant.reportUrl : constant.imageBaseURL,
    imageBaseURL: constant.imageBaseURL,
    imageS3BaseURL: constant.imageS3BaseURL,
    data_loading: false,
    usersArray: Object.keys(userDetailsArray),
    UsersDetails: {
      ...userDetailsArray,
    },
    OrganizationGlobalOptions: [],
    secureStore: {
      set: authenticationService.set,
      get: authenticationService.get,
      remove: function(key) {
        window.localStorage.removeItem(key);
      },
    },
    toursShownOnPage: [],
    getMycinemaStatus: "N",
  };
};
const computed = {
  _getCountryList() {
    return (key, Id) => {
      return [];
    };
  },
  GetRoleId() {
    const { role_id } = authenticationService.get("USINFO");
    return role_id;
  },
  _DateFormat() {
    return constant.dateFormat;
  },
  TimeFormat() {
    return this.$store.getters.TimeFormat;
  },
  CLIENT_SETUP_NAME() {
    return this.$store.getters.CLIENT_SETUP_NAME;
  },
  MIN_FRACTION_DIGITS() {
    return this.$store.getters.MIN_FRACTION_DIGITS;
  },
  curr_code_mixin() {
    return this.$store.getters.getCurrencyData["curr_code"];
  },
  REPORT_URL() {
    return require("@/config/index").REPORT_URL || BASEURL;
  },
  currFormat() {
    let cFormat;
    let precesion;
    let global_options_latest = this.$store.getters.getGlobalOptions;
    cFormat = global_options_latest
      ? global_options_latest.find((x) => {
          return x.go_key == "CURR_FORMAT";
        })
      : null;
    precesion = global_options_latest
      ? global_options_latest.find((x) => {
          return x.go_key == "MIN_FRACTION_DIGITS";
        })
      : null;
    if (cFormat && cFormat.go_value) {
      cFormat = cFormat.go_value;
    } else {
      cFormat = "en-US";
    }
    if (precesion && precesion.go_value) {
      precesion = precesion.go_value;
    } else {
      precesion = 2;
    }
    return getNumberFormatter(cFormat, precesion);
  },
  currFormat3() {
    let cFormat;
    let precesion;
    let global_options_latest = this.$store.getters.getGlobalOptions;
    cFormat = global_options_latest
      ? global_options_latest.find((x) => {
          return x.go_key == "CURR_FORMAT";
        })
      : null;
    precesion = global_options_latest
      ? global_options_latest.find((x) => {
          return x.go_key == "MIN_FRACTION_DIGITS";
        })
      : null;
    if (cFormat && cFormat.go_value) {
      cFormat = cFormat.go_value;
    } else {
      cFormat = "en-US";
    }
    if (precesion && precesion.go_value) {
      precesion = precesion.go_value;
    } else {
      precesion = 2;
    }
    precesion = 3;
    return getNumberFormatter(cFormat, precesion);
  },
};

const getFirstUserData = async (user_id) => {
  const { data } = await MasterService.GetUserInfoById({ user_id });
  return data;
};
const methods = {
  getSafe(
    fn,
    fallbackValue = undefined,
    useFallbackForFalsyGetSafeValue = true
  ) {
    try {
      let result = fn();

      if (!result && useFallbackForFalsyGetSafeValue) {
        result = fallbackValue;
      }

      return result;
    } catch (e) {
      return fallbackValue;
    }
  },
  authorizeClient(clientNames) {
    let isShow = false;
    let clientSetupName = this.$store.getters.CLIENT_SETUP_NAME;
    if (clientNames.length > 0 && clientSetupName) {
      isShow = clientNames.includes(clientSetupName);
    }
    return isShow;
  },
  validateShowCinema(cinema_id) {
    let loggedCinemaId = window.localStorage.getItem("cinema_id");
    let userId = authenticationService.get("USINFO").user_id;
    let status = true;
    if (cinema_id && loggedCinemaId) {
      if (
        cinema_id == authenticationService.get("USINFO").cinema_id &&
        loggedCinemaId == cinema_id
      ) {
        status = true;
      } else {
        status = false;
      }
    } else {
      status = false;
    }
    if (!status) {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Validate Cinema ID FALIED WE GET SHOW CINEMA ID ${cinema_id} but USER CINEMA ID IS ${loggedCinemaId} and user id is ${userId}`,
        page_name: "POS booking",
        api_name: window.location.hash,
      });
    }
    return status;
  },
  getNegativeValue(value) {
    if (value) {
      return "-" + parseFloat(value).toFixed(this.MIN_FRACTION_DIGITS);
    } else {
      return parseFloat(0).toFixed(this.MIN_FRACTION_DIGITS);
    }
  },
  getMyCinemaStatusNew() {
    return this.secureStore.get("MYCINEMASTATUS");
  },
  goBack: function(error) {
    if (
      this.$route.path.includes('/private-rate-card-v2') ||
      this.$route.path.includes('/private-rate-card-with-gst-sc') ||
      this.$route.path.includes('/private-rate-card-exclusive-tax')
    ) {
      this.$router.push({
        path: "/cinema-manager/list-private-rate-card"
      });
    } else {
      this.$router.go(-1);
    }
  },
  _CatchError: function(error) {
    console.log({ error })

    Vue.toasted.show(
      error || "Sorry! Something went wrong. kindly contact your administrator"
    );
  },
  showLoading: function() {
    // this.data_loading = true;
  },
  hideLoading: function() {
    // this.data_loading = false
  },
  _GoToSomethingWentWrong: function() {
    this.$router.push({
      path: "/something-went-wrong",
    });
  },
  _GoToAccessDenied: function() {
    this.$router.push({
      path: "/access-denied",
    });
  },
  _GoToError404: function() {
    this.$router.push({
      path: "/404",
    });
  },
  _GoToRoute: function(path) {
    this.$router.push({
      path: path,
    });
  },
  _GetGlobalOptions: function() {
    return new Promise((resolve, reject) => {
      MasterService.GetGlobalOptions()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.secureStore.set("GLOP", data.Records);

            data.Records.map((x) => {
              if (x.go_key === "CURRENCY") {
                // BRIJ GLOBAL OPTIONS CURRENCY
                this.secureStore.set("BRGLOPCUR", x.go_value);
                this.secureStore.set("BRGLOPCU", x);
              } else if (x.go_key === "APPLICATION_LANGUAGE") {
                // BRIJ GLOBAL OPTIONS APPLICATION_LANGUAGE
                if (x.go_value && String(x.go_value).length > 0) {
                  this.secureStore.set("BRGLOPAL", x.go_value);
                }
              } else if (x.go_key === "OPERATION_COUNTRY") {
                // BRIJ GLOBAL OPTIONS OPERATION COUNTRY
                this.secureStore.set("BRGLOPCO", x.go_value);
              } else if (x.go_key === "STOCK_DIRECT_TRANSFER") {
                // BRIJ GLOBAL OPTIONS STOCK DIRECT TRANSFER
                this.secureStore.set("BRGLOPSTDITR", x.go_value);
              } else if (x.go_key === "STOCK_DEDUCTION") {
                // BRIJ GLOBAL OPTIONS STOCK DEDUCTION
                this.secureStore.set("BRGLOPSTDE", x.go_value);
              } else if (x.go_key === "STOCK_DEDUCTION_CONCESSION") {
                // BRIJ GLOBAL OPTIONS STOCK DEDUCTION CONCESSION
                this.secureStore.set("BRGLOPSTDECO", x.go_value);
              } else if (x.go_key === "ENABLE_FNB") {
                this.secureStore.set("ENABLE_FNB", x.go_value);
              } else if (x.go_key === "RESERVE_SEAT_IMMEDIATELY") {
                // BRIJ GLOBAL OPTIONS RESERVE SEAT IMMEDIATELY
                this.secureStore.set("BGORST", x.go_value);
              } else if (x.go_key === "ALLOW_PAST_BOOKING") {
                // BRIJ GLOBAL OPTIONS ALLOW PAST BOOKING
                this.secureStore.set("BGOAPB", x.go_value);
              } else if (x.go_key === "CHECK_HARWARE_SETTINGS") {
                // BRIJ GLOBAL OPTIONS CHECK HARWARE SETTINGS
                this.secureStore.set("BGOCHS", x.go_value);
              } else if (x.go_key === "POS_CUSTOMER_POPUP") {
                // BRIJ GLOBAL OPTIONS POS CUSTOMER POPUP
                this.secureStore.set("BGOPCP", x.go_value);
              } else if (x.go_key === "MYCINEMA_STATUS") {
                this.getMycinemaStatus = x.go_value;
                // BRIJ GLOBAL OPTIONS POS CUSTOMER POPUP
                this.secureStore.set("MYCINEMASTATUS", x.go_value);
              }
            });

            resolve("data.Records");
          } else {
            // Show Error
            reject(data.message);
          }
        })
        .catch((error) => {
          //Catch Error
          reject("catch error on GetGlobalOptions");
        });
    });
  },
  _GetViewUsersDetails: function(user_id) {
    let string = "";
    let promise = getFirstUserData(user_id).then((res) => {
      string =
        res.status && res["Records"] && res.Records.length > 0
          ? res.Records[0].user_name
          : "-";
    });
    return promise;
  },
  CreateFilterObject: function(array) {
    let obj = {};
    array.map((x) => {
      obj[x.key] = "";
    });
    return obj;
  },
  GetMonthFirstDate: function() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, "01"].join("-");
  },
  GetCurrentDate: function() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },
  formatDate: function(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  },
  _formatDate_dd_mm_yyyy: function(date) {
    var d = new Date(date);
    let formatted_date =
      d.getDate() +
      "-" +
      (d.getMonth() + 1) +
      "-" +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();
    return formatted_date;
  },
  getRequestBody: function(method = "GET", array = [], Methods = {}) {
    let payload = {};
    (async function() {
      const promises = array.map((x) => {
        payload[x.fieldname] = x.fieldvalue;
      });
      await Promise.all(promises);
    })();
    if (method == "POST") {
      return {
        url: Methods[method] + Methods["tableName"], // + Methods["urlKey"],
        method,
        payload,
      };
    } else if (method == "PUT") {
      let url = null;
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }

      return {
        url,
        method: "PUT",
        payload,
      };
    } else if (method == "GET") {
      let url = null;
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }

      return {
        url,
        method: "GET",
        payload: {},
      };
    } else if (method == "GET_ONE") {
      let url = null;
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }

      return {
        url,
        method: "GET",
        payload: {},
      };
    } else {
      return {
        url: "",
        method: "GET",
        payload: {},
      };
    }
  },
  _GetImagePath: function(imagePath) {
    if (imagePath && imagePath.length > 0) {
      var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      var regex = new RegExp(expression);

      if (imagePath.match(regex)) {
        return imagePath;
      }
      if (imagePath.match(/S3\//g)) {
        return `${constant.imageS3BaseURL}${imagePath}`;
      } else {
        return `${constant.imageBaseURL}${imagePath}`;
      }
    }
  },
  getSafe(fn, fallbackValue = undefined, useFallbackForFalsyGetSafeValue = true) {
    try {
      let result = fn()

      if (!result && useFallbackForFalsyGetSafeValue) {
        result = fallbackValue
      }

      return result
    } catch (e) {
      return fallbackValue
    }
  },
  _downloadImagePath: function(imagePath, fileName) {
    let imageUrl = `${constant.imageBaseURL}${imagePath}`;
    axios
      .get(imageUrl, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);
  },
  startTour: function(name) {
    if (this.$tours[name]) {
      this.$tours[name].start();
      if (!this.toursShownOnPage.includes(name)) {
        this.toursShownOnPage.push(name);
      }
    }
  },
  closeTour: function(name) {
    if (
      this.$tours[name] &&
      this.toursShownOnPage &&
      this.toursShownOnPage.length > 0
    ) {
      this.toursShownOnPage.forEach((name) => {
        if (this.$tours[name]) {
          this.$tours[name].stop();
        }
      });
    }
  },
  // isValidNumberString: function(s, precesion = 7){
  //   const re = /^-?\d{1,precesion}(?:\.\d{1,precesion})?$/;

  //   return re.test(String(s).trim());
  // },
  isValidNumberString(s, integerDigits = 7, decimalDigits = 7) {
    const re = new RegExp(`^-?\\d{1,${integerDigits}}(?:\\.\\d{1,${decimalDigits}})?$`);
    return re.test(String(s).trim()); 
  },
  sanitizeTruncate: function(s, integerDigits = 7, decimalDigits = 7) {
    if (s == null) return s;
    s = String(s).trim();
    const neg = s.startsWith('-') ? '-' : '';
    if (neg) s = s.slice(1);

    const parts = s.split('.');
    let intPart = parts[0].replace(/^0+(?!$)/, ''); // remove leading zeros but keep single 0
    if (intPart === '') intPart = '0';

    if (intPart.length > integerDigits) {
      intPart = intPart.slice(0, integerDigits);
    }

    let frac = parts[1] || '';
    if (frac.length > decimalDigits) frac = frac.slice(0, decimalDigits); // truncate fractional
    return neg + intPart + (frac ? '.' + frac : '');
  },
  getLangSpecificAttribute,
  getLangSpecificContent,
  trans
};

const beforeDestroy = function() {
  if (this.toursShownOnPage && this.toursShownOnPage.length > 0) {
    this.toursShownOnPage.forEach((name) => {
      if (this.$tours[name]) {
        this.$tours[name].stop();
      }
    });
  }
};

const storeService = {
  data: () => data(),
  computed,
  methods,
  beforeDestroy,
};

export default storeService;



// WEBPACK FOOTER //
// ./src/util/utilMixin/index.js